import React from 'react'
import classnames from 'classnames'

import { Button } from 'components'

const PrimaryButton = ({ className, ...rest }) => (
  <Button className={classnames('bg-white', className)} textColor="text-black" {...rest} />
)

export default PrimaryButton
